import { useMemo } from 'react';
/**
 * useNormalizedOptions
 * @param rawOptions array of various data types that can be converted into an option
 * @returns
 */
export const useNormalizedOptions = (rawOptions = []) => {
    // TODO: Convert fancier data structures into a flat list of options
    // TODO: Figure out grouping options
    // https://issues.teslamotors.com/browse/AWSM-4130
    // Convert options in whatever format they are to the standard value + label
    const options = useMemo(() => {
        return rawOptions.map((rawOption) => {
            // String > Option
            if (typeof rawOption === 'string') {
                return { label: rawOption, value: rawOption };
            }
            // Default to assuming it's a fleshed out option object
            return rawOption;
        });
    }, [rawOptions]);
    return options;
};
